/**
 * Possible states for the IStompSocket
 */
export var StompSocketState = /*#__PURE__*/function (StompSocketState) {
  StompSocketState[StompSocketState["CONNECTING"] = 0] = "CONNECTING";
  StompSocketState[StompSocketState["OPEN"] = 1] = "OPEN";
  StompSocketState[StompSocketState["CLOSING"] = 2] = "CLOSING";
  StompSocketState[StompSocketState["CLOSED"] = 3] = "CLOSED";
  return StompSocketState;
}(StompSocketState || {});
/**
 * Possible activation state
 */
export var ActivationState = /*#__PURE__*/function (ActivationState) {
  ActivationState[ActivationState["ACTIVE"] = 0] = "ACTIVE";
  ActivationState[ActivationState["DEACTIVATING"] = 1] = "DEACTIVATING";
  ActivationState[ActivationState["INACTIVE"] = 2] = "INACTIVE";
  return ActivationState;
}(ActivationState || {});
/**
 * Possible reconnection wait time modes
 */
export var ReconnectionTimeMode = /*#__PURE__*/function (ReconnectionTimeMode) {
  ReconnectionTimeMode[ReconnectionTimeMode["LINEAR"] = 0] = "LINEAR";
  ReconnectionTimeMode[ReconnectionTimeMode["EXPONENTIAL"] = 1] = "EXPONENTIAL";
  return ReconnectionTimeMode;
}(ReconnectionTimeMode || {});
/**
 * Possible ticker strategies for outgoing heartbeat ping
 */
export var TickerStrategy = /*#__PURE__*/function (TickerStrategy) {
  TickerStrategy["Interval"] = "interval";
  TickerStrategy["Worker"] = "worker";
  return TickerStrategy;
}(TickerStrategy || {});

